import React from "react"

import {FieldViewProps} from "../../../../render/view"

export default function FieldCustomViewUserAccess_GListView(props: FieldViewProps) {

    const value = props.model[props.field.fieldId]

    const option = props.field._getOption(value)
    if (!option) return null

    const optionColor = _.get(option, 'color', null) //!_.isNil(option.color) ? option.color : null;

    if (optionColor) {
        const classes = Classes("ui5-txt-default fl-ac m-t-4 m-b-4 p-l-10", props.className)
        const pillClasses = Classes("ui5-pillbox s22", "gd-c-bgp-"+optionColor, "gd-c-pale-border-"+optionColor, props.className)

        return (
            <div className={classes}>
                <div className={pillClasses}>
                    {option.label}
                </div>
            </div>
        )
    }

    const classes = Classes("ui5-txt-less-important-small min-w-125 p-l-10 m-l-1", props.className)
    return (
        <div className={classes}>
            {_.get(props.field.components, 'ValueIcon', false)}
            <span className="txt-truncate">{option.label}</span>
        </div>
    )
}